<template>
  <div class="report-stock">
    <NavBar class="nav--bar" />
    <AuthBySessionExpired class="auth--by--session--expired" />
    <div class="container">
      <b-modal
        id="filter"
        size="md"
        no-close-on-backdrop
        hide-footer
        title="FILTRAR"
      >
        <div class="row">
          <div
            class="col-xl-12 col-sm-12 col-md-12 col-sm-12 col-12 text-center"
          >
            <label>FILTRAR POR RESIDENTES</label>
            <div class="d-flex align-items-center justify-content-center">
              <div class="form-check m-1">
                <input
                  :disabled="loading"
                  class="form-check-input"
                  type="checkbox"
                  v-model="resident_active"
                  @change="getResidents"
                  id="resident_active"
                />
                <label class="form-check-label" for="resident_active">
                  ATIVOS
                </label>
              </div>
              <div class="form-check m-1">
                <input
                  :disabled="loading"
                  class="form-check-input"
                  type="checkbox"
                  v-model="resident_not_active"
                  @change="getResidents"
                  id="resident_not_active"
                />
                <label class="form-check-label" for="resident_not_active">
                  INATIVOS
                </label>
              </div>
            </div>
          </div>
          <div
            class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
            v-if="!select_all_residents"
          >
            <label>SELECIONE O RESIDENTE</label>
            <select v-model="resident_id" class="form-control">
              <option
                v-for="resident in residents"
                :key="resident.id"
                :value="resident.id"
              >
                {{ String(resident.name).toUpperCase() }} -
                {{ String(resident.status_type_name).toUpperCase() }}
              </option>
            </select>
          </div>
          <div class="col-xl-12 col-sm-12 col-md-12 col-sm-12 col-12 pt-0 pb-0">
            <ErrorsMessages :errors="errors" />
          </div>
          <div
            class="col-xl-12 col-sm-12 col-md-12 col-sm-12 col-12 text-right"
          >
            <v-btn
              :disabled="loading"
              @click="paginate()"
              class="btn-filter"
              type="relief"
              ><i class="fas fa-filter mr-2 text-twenty"></i>

              {{ loading ? "CARREGANDO" : "FILTRAR" }}
            </v-btn>
          </div>
        </div>
      </b-modal>
      <div class="row filters">
        <div class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12 pt-0">
          <v-btn class="btn-return" v-on:click="handleToBack">
            <i class="fas fa-arrow-left mr-1"></i> VOLTAR
          </v-btn>
        </div>
        <div class="col-xl-11 col-lg-10 col-md-10 col-sm-9 col-12 pt-0">
          <h1 class="title-pages pt-1 check-text-center">
            RELATÓRIO - ESTOQUE DE MEDICAMENTOS ESGOTANDO - PRESCRIÇÃO ATUAL
          </h1>
        </div>
      </div>
      <div class="row filters">
        <!-- <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
          <v-text-field label="Filtrar por lote" outlined />
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
          <v-text-field label="Filtrar por residente" outlined />
        </div> -->
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-right">
          <v-btn
            @click="$bvModal.show('filter')"
            class="btn-filter mr-2"
            type="relief"
          >
            <i class="fas fa-filter mr-2 text-twenty"></i> FILTRAR
          </v-btn>
          <v-btn
            :disabled="items.length == 0"
            @click="print"
            class="btn-print"
            type="relief"
          >
            <i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR
          </v-btn>
        </div>
        <div
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0"
          v-if="items.length > 0"
        >
          <h6 class="mb-0 upper-text worksansr check-text-center">
            FILTRANDO:
            <span v-if="select_all_residents"
              ><strong>TODOS OS RESIDENTES</strong> |
            </span>
            <span v-if="!select_all_residents"
              ><strong>{{ items[0].name }}</strong> |
            </span>
          </h6>
        </div>
      </div>
      <b-overlay :show="loading" opacity="0.99">
        <table v-for="(resident, key) in items" :key="key">
          <thead>
            <tr>
              <td>
                <div class="header-space">
                  <div class="row">
                    <div
                      class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-12 check-text-center text-center pt-0 pb-0"
                    >
                      <img
                        v-if="rest_home_logo_url"
                        class="rest_home_logo_url"
                        :src="rest_home_logo_url"
                      />
                      <div v-if="!rest_home_logo_url" class="ml-1">
                        <strong class="text-uppercase check-text-center">{{
                          rest_home_name
                        }}</strong>
                      </div>
                    </div>
                    <div
                      class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-12 d-flex align-items-center pt-0 pb-0"
                    >
                      <img
                        v-if="resident.photo_url"
                        class="resident_photo_url"
                        :src="resident.photo_url"
                      />
                      <img
                        v-if="!resident.photo_url"
                        class="resident_photo_url"
                        :src="require('../../../assets/user.png')"
                      />
                      <div class="ml-3">
                        <h6 class="m-0">
                          {{ resident.name }}
                        </h6>
                        <h6 class="legends mb-1 worksansr">
                          Data de nascimento:

                          {{ formatDate(resident.date_of_birth, false) }}
                          -
                          {{ getAge(resident.date_of_birth) }}
                          anos
                        </h6>
                        <h6 class="legends mb-1 worksansr">
                          Data de admissão:
                          {{ formatDate(resident.date_of_reception, false) }}
                        </h6>
                        <h6
                          class="legends mb-1 worksansr"
                          v-if="resident.bed_id"
                        >
                          Leito Nº:{{ resident.bed_number }}, Andar:
                          {{ resident.bed_walk }}, ALA/Setor:
                          {{ resident.bed_ward_or_sector }}, Quarto:
                          {{ resident.bed_bedroom }}
                        </h6>
                        <h6 class="legends mb-1 worksansr">
                          Cadastrado:
                          {{ formatDate(resident.created_at, false) }}
                        </h6>
                      </div>
                    </div>
                    <div
                      class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-12 check-text-right pt-0 pb-0"
                    >
                      <img class="logo" :src="logo" />
                    </div>
                    <div
                      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-center pt-0 pb-0 show-on-print"
                    >
                      <h1 class="title-pages check-text-center">
                        ESTOQUE DE MEDICAMENTOS ESGOTANDO - PRESCRIÇÃO ATUAL
                      </h1>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div class="content">
                  <section v-if="!resident.exist_group_prescription_medicine">
                    <h5
                      class="text-center upper-text color-sysblue back-ground-grey p-2"
                    >
                      Residente não possui prescrição ativa!
                    </h5>
                  </section>
                  <section>
                    <h5
                      class="text-center upper-text color-sysblue back-ground-grey p-2"
                    >
                      Medicamentos sem estoque
                    </h5>
                    <Medicines
                      title="Medicamentos sem estoque"
                      :medicines="resident.medicines_out_of_stock"
                    />
                  </section>
                  <hr style="margin: 2px 0px" />
                  <section>
                    <h5
                      class="text-center upper-text color-sysblue back-ground-grey p-2"
                    >
                      ESGOTANDO entre 1 a 7 dias
                    </h5>
                    <Medicines
                      title="ESGOTANDO entre 1 a 7 dias"
                      :medicines="resident.they_will_end_in_one_to_seven_days"
                      expected_end_date="true"
                    />
                  </section>
                  <hr style="margin: 2px 0px" />
                  <section>
                    <h5
                      class="text-center upper-text color-sysblue back-ground-grey p-2"
                    >
                      ESGOTANDO entre 8 a 15 dias
                    </h5>
                    <Medicines
                      title="ESGOTANDO entre 8 a 15 dias"
                      :medicines="
                        resident.they_will_end_in_eight_to_fifteen_days
                      "
                      expected_end_date="true"
                    />
                  </section>
                  <hr style="margin: 2px 0px" />
                  <section>
                    <h5
                      class="text-center upper-text color-sysblue back-ground-grey p-2"
                    >
                      ESGOTANDO entre 16 a 30 dias
                    </h5>
                    <Medicines
                      title="ESGOTANDO entre 16 a 30 dias"
                      :medicines="
                        resident.they_will_end_in_sixteen_to_thirty_days
                      "
                      expected_end_date="true"
                    />
                  </section>
                  <hr style="margin: 2px 0px" />
                  <section>
                    <h5
                      class="text-center upper-text color-sysblue back-ground-grey p-2"
                    >
                      ESGOTANDO entre 31 a 90 dias
                    </h5>
                    <Medicines
                      title=" ESGOTANDO entre 31 a 90 dias"
                      :medicines="resident.will_end_over_thirty_days"
                      expected_end_date="true"
                    />
                  </section>
                  <hr style="margin: 2px 0px" />
                  <section>
                    <h5
                      class="text-center upper-text color-sysblue back-ground-grey p-2"
                    >
                      ESGOTANDO acima de 90 dias
                    </h5>
                    <Medicines
                      title="ESGOTANDO acima de 90 dias"
                      :medicines="resident.will_end_over_ninety_one_days"
                    />
                  </section>
                  <hr style="margin: 2px 0px" />
                  <section>
                    <h5
                      class="text-center upper-text color-sysblue back-ground-grey p-2"
                    >
                      Medicamentos que não estão na prescrição
                    </h5>
                    <Medicines
                      title="Medicamentos que não estão na prescrição"
                      :medicines="resident.medicines_dont_have_on_prescription"
                    />
                  </section>
                  <div class="text-center">
                    <hr class="border-black m-0" />
                    (Assinatura eletrônica)
                    {{
                      professionalClassCouncilValue({
                        id: user.professional_class_council_id,
                        name: user.name,
                        profile: user.profile_name,
                        cpf: user.cpf,
                        office: user.office,
                        value: user.professional_class_council_value,
                      })
                    }}
                    <small>
                      - {{ moment().format("DD/MM/YYYY HH:mm:ss") }}
                    </small>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <errors-messages :errors="errors" />
      </b-overlay>
    </div>
  </div>
</template>

<script>
import api from "../../../services/api";

import routes from "../../../routes";

import { formatDate, professionalClassCouncilValue } from "../../../lib/format";

import { getAge } from "../../../lib/getAgeByDate";

import AuthBySessionExpired from "../../Components/AuthBySessionExpired";

import NavBar from "../../NavBar";

import ErrorsMessages from "../../Components/ErrorsMessages";

import Medicines from "./Medicines";

import { userData } from "../../../lib/functions";

import moment from "moment";

export default {
  name: "ReportsStock",
  components: {
    NavBar,
    AuthBySessionExpired,
    Medicines,
    ErrorsMessages,
  },
  data() {
    return {
      user: {},
      resident_active: true,
      resident_not_active: false,
      items: [],
      residents: [],
      resident_id: "",
      filter: "SEM_ESTOQUE",
      rest_home_name: "",
      rest_home_fantasy_name: "",
      rest_home_logo_url: null,
      logo: null,
      loading: false,
      select_all_residents: false,
      errors: [],
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    getAge,
    moment,
    formatDate,
    professionalClassCouncilValue,
    async retrieve() {
      const { user, logo } = userData();

      this.user = user;
      this.rest_home_name = user.rest_home_name;
      this.rest_home_fantasy_name = user.rest_home_fantasy_name;
      this.rest_home_logo_url = user.logo_url;
      this.logo = logo;

      await this.getResidents();

      let { modal } = this.$router.currentRoute.query;

      if (modal) {
        this.$bvModal.show("filter");
      }
    },
    async getResidents() {
      try {
        let { resident_active, resident_not_active } = this;

        let status = "ATIVO";

        if (resident_active && resident_not_active) {
          status = "ALL";
        } else if (!resident_active && resident_not_active) {
          status = "INATIVO";
        } else if (!resident_active && !resident_not_active) {
          this.errors = [
            {
              id: this.errors.length,
              message: "Informe residentes ativos, inativos ou ambos",
            },
          ];
          this.residents = [];
          return;
        }

        let params = { status };

        const response = await api.get("/rest-home/resident/paginate", {
          params,
        });

        const { error, errors, residents } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.residents = residents;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async paginate() {
      try {
        this.loading = true;

        this.items = [];

        const { resident_id, select_all_residents } = this;

        var params = { resident_id, select_all_residents };

        const response = await api.get("/rest-home/report/stock/filter", {
          params,
        });

        const { residents, error, errors } = response.data;

        if (error) {
          this.items = [];
          this.errors = errors;
        } else {
          this.items = residents;
          this.errors = [];
          this.$bvModal.hide("filter");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    print() {
      window.print();
      routes;
      // let route = this.$router.resolve({
      //   name: "report_stock",
      //   params: {},
      // });

      // window.open(route.href, "_blank");
    },
    handleToBack: () => routes.go(-1),
  },
};
</script>

<style>
.report-stock table {
  width: 100%;
}

.report-stock .header,
.report-stock .header-space {
  height: 125px;
}

.report-stock .logo {
  height: 50px;
  object-fit: contain;
}
.report-stock .rest_home_logo_url {
  height: 80px;
  width: 100%;
  object-fit: contain;
}
.report-stock .resident_photo_url {
  width: 80px;
  height: 80px;
  border-radius: 40px;
  object-fit: cover;
}

.report-stock .show-on-print {
  display: none;
}
@media print {
  .report-stock table {
    page-break-after: always !important;
  }
  .report-stock table section {
    page-break-inside: avoid !important;
  }
  .report-stock table .content-medicine {
    page-break-inside: avoid !important;
  }
  .report-stock table .tbody-table-stock tr {
    page-break-inside: avoid !important;
  }
  .report-stock .nav--bar {
    display: none;
  }
  .report-stock .auth--by--session--expired {
    display: none;
  }
  .report-stock .filters {
    display: none;
  }
  .report-stock button {
    display: none;
  }
  .report-stock .show-on-print {
    display: block;
  }
}
</style>
